import React = require('react');
import FlatButton from "material-ui/FlatButton";
import HomeIcon from "material-ui/svg-icons/action/home";
import EditIcon from "material-ui/svg-icons/maps/rate-review";
import PublishIcon from "material-ui/svg-icons/av/web";

import l10n from 'diy/util/l10n';

interface AssistanceViewProps {
    websiteUrl: string;
    buttonActionHandler: Function;
    stepActionHandlers: Array<Function>;
}

export default class AssistanceView extends React.Component<AssistanceViewProps, any> {

    render() {
        return (
            <div>
                <div className="assistance-dialog-container">
                    <h3>{l10n("migration.assistance.title")}</h3>
                    <p className="subtitle">
                        {l10n("migration.assistance.subtitle")}
                    </p>
                    <div className="steps">
                        <a classID="step1" className="step" href="#"
                           onClick={(event: React.MouseEvent<{}>) => this.onStepClick(1, event)}>
                            <div className="icon"><HomeIcon color="#424952" /></div>
                            <h4>{l10n("migration.assistance.step1.title")}</h4>
                            <div className="content" dangerouslySetInnerHTML={{__html:
                                l10n("migration.assistance.step1.content")
                            }}>
                            </div>
                        </a>
                        <a classID="step2" className="step" href="#"
                           onClick={(event: React.MouseEvent<{}>) => this.onStepClick(2, event)}>
                            <div className="icon"><EditIcon color="#424952" /></div>
                            <h4>{l10n("migration.assistance.step2.title")}</h4>
                            <div className="content" dangerouslySetInnerHTML={{__html:
                                l10n("migration.assistance.step2.content")
                            }}>
                            </div>
                        </a>
                        <a classID="step3" className="step" href="#"
                           onClick={(event: React.MouseEvent<{}>) => this.onStepClick(3, event)}>
                            <div className="icon"><PublishIcon color="#424952" /></div>
                            <h4>{l10n("migration.assistance.step3.title")}</h4>
                            <div className="content" dangerouslySetInnerHTML={{__html:
                                l10n("migration.assistance.step3.content").replace(
                                    "{link}",
                                    `<span class='info-link'>${this.props.websiteUrl}</span>`
                                )
                            }}>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="dialog-actions">
                    <div className="assistance-dialog-help" dangerouslySetInnerHTML={{__html:
                        l10n("migration.assistance.help")
                    }}>
                    </div>
                    <FlatButton label={l10n("migration.assistance.close")}
                                onClick={this.onButtonClick} className="assistance-dialog-button" />
                </div>
            </div>
        );
    }

    private onStepClick = (step: number, event: React.MouseEvent<{}>) => {
        event.preventDefault();

        if (typeof this.props.stepActionHandlers[step - 1] !== "undefined") {
            this.props.stepActionHandlers[step - 1]();
        }
    };

    private onButtonClick = (event: React.MouseEvent<{}>) => {
        event.preventDefault();
        this.props.buttonActionHandler();
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/assistanceDialog/views/AssistanceView.tsx
 **/